<template v-if="user">
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box">
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="alert alert-danger" role="alert">
                   Mobile version is not supported. Please use desktop browsers.
                 </div>
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Player Search
                   </h6>
                   <div class="alert alert-warning" role="alert" v-if="!$root.isAuthenticated">
                     <b>Sign in is required</b> to see player's Steam profile.
                   </div>
                   <div class="element-box-tp">
                     <div class="row">
                       <div class="col-sm-4">
                         <div class="form-group">
                           <label for=""> Location</label><app-places class="form-control" v-model="location" placeholder="Enter your city" @change="val => { mapsLocation = val }" :options="{ countries: ['ID'], type: 'city', aroundLatLngViaIP: false, language: 'en' }"></app-places>
                         </div>
                       </div>
                       <div class="col-sm-2">
                         <div class="form-group">
                           <label for=""> Select Role(s)</label><app-select2 class="form-control" v-model="roles">
                             <option value="leader">
                               Leader
                             </option>
                             <option value="fragger">
                               Fragger
                             </option>
                             <option value="awper">
                               AWPer
                             </option>
                             <option value="rifler">
                               Rifler
                             </option>
                             <option value="coach">
                               Coach
                             </option>
                           </app-select2>
                         </div>
                       </div>
                       <div class="col-sm-2">
                         <div class="form-group">
                           <label for=""> Select Language(s)</label><app-select2 class="form-control" v-model="languages">
                             <option value="en">
                               English
                             </option>
                             <option value="id">
                               Bahasa Indonesia
                             </option>
                             <option value="javanese">
                               Bahasa Jawa
                             </option>
                             <option value="sundanese">
                               Bahasa Sunda
                             </option>
                           </app-select2>
                         </div>
                       </div>
                       <div class="col-sm-2">
                         <div class="form-group">
                           <label for=""> Select Goal(s)</label><app-select2 class="form-control" v-model="goals">
                             <option value="fun">
                               Play for fun
                             </option>
                             <option value="competitively">
                               Play competitively
                             </option>
                             <option value="professionally">
                               Play professionally
                             </option>
                           </app-select2>
                         </div>
                       </div>
                       <div class="col-sm-2">
                         <div class="form-group">
                           <label for=""> Select Abilities</label><app-select2 class="form-control" v-model="abilities">
                             <option value="offline">
                               Play Offline (LAN)
                             </option>
                             <option value="travelling">
                               Travelling
                             </option>
                           </app-select2>
                         </div>
                       </div>
                     </div>
                     <button class="btn btn-primary" type="submit" @click="searchPlayer()"> Search</button></br></br>
                     <div class="table-responsive">
                       <table class="table table-sm table-padded">
                         <thead>
                           <tr>
                             <th></th>
                             <th>Player Info</th>
                             <th>Language(s)</th>
                             <th>Role(s)</th>
                             <th>Goal(s)</th>
                             <th>Abilities</th>
                           </tr>
                         </thead>
                         <tbody>
                           <tr v-for="(player, index) in players">
                             <td><img style="border-radius: 50%; height: 40px;" :src="player.avatar"></td>
                             <td>
                               <a target="_blank" v-bind:href="'https://steamcommunity.com/profiles/' + player.steamid64" v-if="$root.isAuthenticated"><span>{{ player.finder['player'].fullName }}</span></a>&nbsp;
                               <span v-if="!$root.isAuthenticated">{{ player.finder['player'].fullName }}</span>
                               <span class="badge badge-dark" data-toggle="tooltip" data-placement="top" title="Premium+ User" v-if="player.finder['player'].boosted">Boosted</span>
                               <div>
                                 <span class="smaller lighter">{{ player.finder['player'].location['value'] }}</span>
                               </div>
                             </td>
                             <td>
                               <template v-for="(lang, i) in player.finder['player'].languages">
                                 <span class="badge badge-primary" v-if="lang === 'en'">English</span>
                                 <span class="badge badge-warning" v-if="lang === 'id'">Bahasa Indonesia</span>
                                 <span class="badge badge-danger" v-if="lang === 'javanese'">Bahasa Jawa</span>
                                 <span class="badge badge-success" v-if="lang === 'sundanese'">Bahasa Sunda</span>
                               </template>
                             </td>
                             <td>
                               <template v-for="(role, i) in player.finder['player'].roles">
                                 <span class="badge badge-danger" v-if="role === 'leader'">Leader</span>
                                 <span class="badge badge-primary" v-if="role === 'fragger'">Fragger</span>
                                 <span class="badge badge-warning" v-if="role === 'awper'">AWPer</span>
                                 <span class="badge badge-success" v-if="role === 'rifler'">Rifler</span>
                                 <span class="badge badge-dark" v-if="role === 'coach'">Coach</span>
                               </template>
                             </td>
                             <td>
                               <template v-for="(goal, i) in player.finder['player'].goals">
                                 <span class="badge badge-danger" v-if="goal === 'professionally'">Professional</span>
                                 <span class="badge badge-primary" v-if="goal === 'fun'">Fun</span>
                                 <span class="badge badge-warning" v-if="goal === 'competitively'">Competitive</span>
                               </template>
                             </td>
                             <td>
                               <template v-for="(ability, i) in player.finder['player'].abilities">
                                 <span class="badge badge-danger" v-if="ability === 'offline'">Play Offline</span>
                                 <span class="badge badge-primary" v-if="ability === 'travelling'">Travelling</span>
                               </template>
                             </td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.authenticated"></app-invitation>
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from '../partials/Navbar.vue';
import Sidebar from '../partials/Sidebar.vue';
import Alert from '../partials/Alert';
import DarkColor from '../partials/DarkColor';
import RightSidebar from '../partials/RightSidebar';
import Invitation from '../partials/Invitation';
import Places from '../partials/Places';
import Select2 from '../partials/Select2';

export default {
  name: 'Servers',
  metaInfo: {
    title: 'servers',
    titleTemplate: 'onetap | %s',
    meta: [
      { property: 'og:title', content: 'onetap | servers' },
      { property: 'og:site_name', content: 'onetap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://onetap.gg/servers'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'onetap | servers' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      welcomeText: 'Welcome to onetap!',
      players: [],
      languages: [],
      roles: [],
      goals: [],
      abilities: [],
      location: '',
      mapsLocation: null
    }
  },
  computed: {
    //
  },
  methods: {
    getPlayers() {
      this.axios.get(`${this.API_URL}/finder/player`).then((res) => {
        this.players = res.data;
      });
    },
    searchPlayer() {
      if (this.mapsLocation) {
        this.axios.get(`${this.API_URL}/finder/player`, { params: { 'finder.player.languages': this.languages, roles: this.roles, goals: this.goals, abilities: this.abilities, location: this.mapsLocation.value } }).then((res) => {
          this.players = res.data;
        });
      } else {
        this.axios.get(`${this.API_URL}/finder/player`, { params: { languages: this.languages, roles: this.roles, goals: this.goals, abilities: this.abilities } }).then((res) => {
          this.players = res.data;
        });
      }
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  created() {
    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    this.getPlayers();
  },
  mounted() {
    //
  },
  watch: {
    players: function(value) {
      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 600)
    }
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation,
    'app-places': Places,
    'app-select2': Select2
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
